import axios from 'axios';
import { User } from '../models/user';

const locked = {
    getUsers: false
};

export const getUsers = async (): Promise<Undefinable<User[]>> => {
    if (!locked.getUsers) {
        locked.getUsers = true;
        const response = await axios.get(`/api/user`);
        locked.getUsers = false;
        return response.data;
    }
};
